module.exports = __webpack_public_path__ + "static/media/Laura Sparks_1594316810272.7ab0e762.jpg";